import {ProcessDatePicker} from "components";

import {useFormContext, Controller} from "react-hook-form";
import useValidateVoyages from "views/ProcessDetails/hooks/useValidateVoyages";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyageETDField = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();
  const {dateIsFarFromOneYear} = useValidateVoyages();

  return (
    <Controller
      name={
        `boarding.voyages.${index}.estimatedCargoLoad` as `boarding.voyages.0.estimatedCargoLoad`
      }
      control={control}
      rules={{
        validate: {
          dateIsFarFromOneYear: (value) => {
            const dateError = dateIsFarFromOneYear(value);

            if (dateError === "future") {
              return `Data futura inválida para o ETD da viagem ${index + 1}, superior a 12 meses.`;
            }

            if (dateError === "past") {
              return `Data passada inválida para o ETD da viagem ${index + 1}, superior a 12 meses.`;
            }

            if (dateError === "invalid") {
              return `Data inválida para o ETD da viagem ${index + 1}.`;
            }

            return true;
          },
        },
      }}
      render={({field: {value}}) => (
        <ProcessDatePicker
          value={value}
          name={`boarding.voyages.${index}.estimatedCargoLoad`}
          errorName="ETD"
          title={`ETD viagem ${index + 1}`}
          disabled={disabled}
          fullWidth
          label="ETD"
        />
      )}
    />
  );
};

export default VoyageETDField;
